import { Modal } from "../../Modal";
import warningIcon from '../../../../icons/warn.png';
import { FC } from "react";
import { Button } from "../../../Buttons/Button/Button";
import { openBotLink } from "../../../../utils/platform-links";

interface INotAllowWriteNotifyProps {
    closeHandler: () => void;
}

export const NotAllowWriteNotify: FC<INotAllowWriteNotifyProps> = ({ closeHandler }) => {
    const fixHandler = () => {
        if (!openBotLink()) return;
        closeHandler();
    };

    return (
        <Modal
            name='NotAllowWriteNotify'
            title='Внимание!'
            message={(
                <>
                    <p>В случае выигрыша вы не сможете получить подарок!</p>
                    <p>Нужно начать диалог с чат-ботом игры.</p>
                </>
            )}
            icon={warningIcon}
            button={<Button caption='Исправить' type='green' handler={fixHandler} />}
            closeCross={{ onClose: closeHandler }}
        />
    );
};
